import type { ReactNode } from 'react'

/**
 * Состояние: значок и слово, а не только цвет (CLAUDE.md §7). Значок для диктора скрыт — слово его заменяет.
 * Тон меняет и рамку карточки (сплошная, пунктир, двойная, точки), поэтому читается в оттенках серого.
 */
export type MarkTone = 'ok' | 'warn' | 'block' | 'wait'

export function Mark({ glyph, word, tone }: { glyph: string; word: string; tone: MarkTone }) {
  return (
    <span className={`hw-mark hw-mark--${tone}`}>
      <span className="hw-mark__glyph" aria-hidden="true">
        {glyph}
      </span>{' '}
      <strong>{word}</strong>
    </span>
  )
}

/** Текст только для диктора. */
export function ScreenReaderText({ children }: { children: ReactNode }) {
  return <span className="hw-sr">{children}</span>
}
